import React, { useState, useContext } from "react";

import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { isEmpty, size } from "lodash";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { DataContext } from "../../../context/DataContext";
import { useAviso } from "../../../components/base";
import {
  getToken,
  updatePasswordAsync,
} from "../../../api/Account";

const ChangePass = ({ setShowModal }) => {
  const { setIsLoading } = useContext(DataContext);
  const aviso = useAviso();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPasword, setNewPasword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [errores, setErrores] = useState({});

  const token = getToken();

  // Las reglas son las de siempre; ahora el mensaje sale junto al campo y no en una alerta.
  const validateData = () => {
    const faltantes = {};

    if (isEmpty(currentPassword)) {
      faltantes.actual = "Ingrese su contraseña actual";
    }

    if (isEmpty(newPasword)) {
      faltantes.nueva = "Ingrese su nueva contraseña";
    } else if (size(newPasword) < 6) {
      faltantes.nueva = "La nueva contraseña debe tener al menos 6 caracteres";
    }

    if (isEmpty(passwordConfirm)) {
      faltantes.confirmacion = "Confirme su nueva contraseña";
    } else if (newPasword !== passwordConfirm) {
      faltantes.confirmacion = "Las contraseñas no son iguales";
    }

    setErrores(faltantes);
    return isEmpty(faltantes);
  };

  const cambiarPass = async (evento) => {
    evento.preventDefault();
    if (guardando) return;
    if (validateData()) {
      const data = {
        oldPassword: currentPassword,
        newPassword: newPasword,
      };
      setGuardando(true);
      setIsLoading(true);
      const result = await updatePasswordAsync(token, data);
      setGuardando(false);
      if (!result.statusResponse) {
        setIsLoading(false);
        aviso.error(result.error || "No se pudo cambiar la contraseña");
        return;
      }
      setIsLoading(false);
      aviso.exito("Contraseña cambiada");
      setShowModal(false);
    }
  };

  // Escribir en un campo limpia su error.
  const cambiar = (clave, poner) => (e) => {
    poner(e.target.value);
    if (errores[clave]) setErrores({ ...errores, [clave]: undefined });
  };

  const botonVer = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
          sx={{ color: "text.secondary" }}
        >
          <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
        </IconButton>
      </InputAdornment>
    ),
  };

  return (
    <Box
      component="form"
      onSubmit={cambiarPass}
      noValidate
      sx={{ display: "grid", gap: 2.5, pt: 1, minWidth: { sm: 360 } }}
    >
      <TextField
        variant="outlined"
        fullWidth
        required
        onChange={cambiar("actual", setCurrentPassword)}
        value={currentPassword}
        label={"Contraseña actual"}
        type={showPassword ? "text" : "password"}
        autoComplete="current-password"
        error={Boolean(errores.actual)}
        helperText={errores.actual}
        disabled={guardando}
        InputProps={botonVer}
      />

      <TextField
        variant="outlined"
        fullWidth
        required
        onChange={cambiar("nueva", setNewPasword)}
        value={newPasword}
        type={showPassword ? "text" : "password"}
        label={"Contraseña nueva"}
        autoComplete="new-password"
        error={Boolean(errores.nueva)}
        helperText={errores.nueva}
        disabled={guardando}
        InputProps={botonVer}
      />

      <TextField
        variant="outlined"
        fullWidth
        required
        onChange={cambiar("confirmacion", setPasswordConfirm)}
        value={passwordConfirm}
        label={"Confirme su contraseña"}
        type={showPassword ? "text" : "password"}
        autoComplete="new-password"
        error={Boolean(errores.confirmacion)}
        helperText={errores.confirmacion}
        disabled={guardando}
        InputProps={botonVer}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        size="large"
        disabled={guardando}
        startIcon={
          guardando ? <CircularProgress size={18} color="inherit" /> : null
        }
      >
        Cambiar contraseña
      </Button>
    </Box>
  );
};

export default ChangePass;
